// extracted by mini-css-extract-plugin
module.exports = {"title":"NotesModal_title__3eLrt","label":"NotesModal_label__2uJbE"};